export const Branding = Object.freeze({
	/** Historical development codename; never use on public product surfaces. */
	internalCodename: "Trenches Royale",
	displayName: "TRENCHIO",
	shortName: "TRENCHIO",
	description: "A fast, wallet-powered trench battle royale.",
	siteUrl: "https://trenchio.gg",
	domain: "trenchio.gg",
	sourceUrl: "https://github.com/TheNemesis1/trenches-royale",
	chain: {
		name: "Robinhood Chain",
		mainnetId: 4663,
		testnetId: 46630,
	},
});
